import(/* webpackMode: "eager" */ "/var/www/rutavix/frontend/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/var/www/rutavix/frontend/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/var/www/rutavix/frontend/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/rutavix/frontend/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/rutavix/frontend/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/var/www/rutavix/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/rutavix/frontend/src/app/[locale]/ClientBody.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/var/www/rutavix/frontend/src/context/CartContext.tsx");
